var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"prompt"},[_c('span',{staticClass:"prompt-text"},[_vm._v("")]),_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }